import React from "react";
import { Link } from "react-router-dom";
import { Tag } from "antd";
import { RiMoneyDollarCircleFill } from "react-icons/ri";

import config from "@/config";
import { MdLocationPin } from "react-icons/md";

const JobCard = ({ job }) => {
    return (
        <Link
            to={config.routes.job + `/${job.Pk}`}
            className="bg-white p-4 rounded-lg hover:shadow-md hover:border-2 border-2 hover:scale-[1.02]	 hover:border-primary hover:bg-green-50 hover:text-prinamry-hover transition-all flex flex-col justify-between cursor-pointer"
        >
            <div className="flex items-start gap-4">
                <div className="w-32 h-32 md:w-24 md:h-24 lg:w-20 lg:h-20 shrink-0 rounded-lg bg-white hover:-translate-y-1 transition-all">
                    <img
                        src={'/' + job.PhotoCompany}
                        alt={job.JobTitle}
                        className="w-full h-full object-contain"
                    />
                </div>
                <div className="flex-1">
                    <span
                        className=" cursor-pointer hover:text-primary-hover hover:underline font-bold text-lg mb-1 line-clamp-1">
                        {job.JobTitle}
                    </span>
                    <p className="text-gray-600 text-sm mb-1 cursor-pointer line-clamp-1">
                        {job.JobCompanyName}
                    </p>

                    <div className=" flex flex-wrap gap-2 mb-2">
                        <div className="flex gap-1 max-w-[60%] items-center text-gray-600 text-sm">
                            <RiMoneyDollarCircleFill className="text-primary shrink-0" />
                            <span className="line-clamp-1">{job.JobSalary ? /^\d+$/.test(job.JobSalary) ? `${(+job.JobSalary).toLocaleString('vi-VN')}` : job.JobSalary : "Thỏa thuận"}</span>
                        </div>
                        <div className="flex gap-1 items-center text-gray-600 text-sm">
                            <MdLocationPin className="text-primary shrink-0" />
                            <span className="line-clamp-1">{job.PlaceWork || "Liên hệ"}</span>
                        </div>
                    </div>

                    <div className="flex flex-wrap gap-2">
                        {job.JobKind === '0' && (
                            <Tag color="green">Tuyển dụng nhanh</Tag>
                        )}
                        <Tag color="blue">Số lượng: {job.JobQuantity || "Liên hệ"}</Tag>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default JobCard;
